import { ReactElement } from "react";
import { EmailGlobalSearchResultItem, GlobalSearchScopeIdentifier } from "client/Api/TitleBar/GlobalSearch/globalSearch";
import { TimeZone } from "client/DateAndTime/timezones";
import { EmailListItem } from "../../../Items/EmailListItem";
import { GlobalSearchItem } from "../../../GlobalSearchItem/GlobalSearchItem";
import { generateTrackingId } from "client/Misc/utils";
import { useEmailNavigationHandler } from "../../../Navigation/useEmailNavigationHandler";

export type EmailItemViewProps = {
	item: EmailGlobalSearchResultItem;
	itemIndex: number;
	itemScope: GlobalSearchScopeIdentifier;
	timezone: TimeZone;
	tabIndex: number;
};

export const EmailItemView = (props: EmailItemViewProps): ReactElement => {
	const {
		item,
		itemIndex,
		itemScope,
		timezone,
		tabIndex
	} = props;

	const {
		item: {
			subject,
			ownerName,
			receivedDateTime,
			emailId,
		},
		parentFolderName,
		hitHighlights,
		color
	} = item;

	const openHandler: () => void = useEmailNavigationHandler({
		emailId: emailId.id,
		searchResult: item,
		itemScope
	});

	return (
		<GlobalSearchItem
			trackingId={generateTrackingId("email-item", `|${emailId.id}`)}
			onClick={openHandler}
		>
			<EmailListItem
				emailId={emailId.id}
				ownerName={ownerName}
				parentFolderName={parentFolderName}
				receivedDateTime={receivedDateTime}
				subject={subject}
				timezone={timezone}
				hitHighlights={hitHighlights}
				itemIndex={itemIndex}
				tabIndex={tabIndex}
				onExecute={openHandler}
				color={color}
			/>
		</GlobalSearchItem>
	);
};

EmailItemView.displayName = "EmailGlobalSearchItemView";
